export const ACCOMMODATION_DESC_MIN_LENGTH = 10;
export const ACCOMMODATION_DESC_MAX_LENGTH = 500;

export const ACCOMMODATION_NAME_MIN_LENGTH = 2;
export const ACCOMMODATION_NAME_MAX_LENGTH = 15;

export const ADDRESS_TYPE_ROAD = 'R';
